<template>
  <div class="w-full">
    <div class="mt-4 bg-white border border-gray-200 p-4">
      <h2 class="text-lg">Search for a sale</h2>
      <div
        class="flex flex-row justify-between items-center content-center pt-2"
      >
        <div class=" flex flex-row items-center content-center space-x-4">
          <label
            for="invoice_number"
            class="block text-sm font-medium text-gray-600"
            >Invoice Number</label
          >
          <input
            type="number"
            name="invoice_number"
            id="invoice_number"
            class="mt-1 focus:ring-blue-500 focus:border-blue-500 block pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm"
            placeholder="0"
            aria-describedby="price-currency"
            v-model="invoiceNumber"
          />
          <button
            class="px-3 py-1.5 bg-blue-600 focus:outline-none rounded-lg text-white"
            v-on:click="searchInvoice"
          >
            Search
          </button>
        </div>
        <div class="flex-1 flex flex-row justify-end space-x-2">
          <button
            class="px-3 py-1.5 bg-blue-600 focus:outline-none rounded-lg text-white"
            v-on:click="selectAll"
            v-if="sales.length > 0"
          >
            Select All
          </button>
          <button
            class="px-3 py-1.5 bg-green-600 focus:outline-none rounded-lg text-white"
            v-if="shouldShowFinalizeButton"
            v-on:click="finalizeSelectedSales"
          >
            Finalize Selected Sales
          </button>
        </div>
      </div>
    </div>

    <div
      class="mt-4 bg-white border border-gray-200 flex flex-col items-center content-center justify-center py-24 space-y-8"
      v-if="sales.length == 0 && invoiceNumber == null && polling == false"
    >
      <span
        >Type an invoice number to populate sales. If you have searched, no
        sales may exist for the invoice number.</span
      >
    </div>

    <div
      class="mt-4 bg-white border border-gray-200 flex flex-col items-center content-center justify-center py-24 space-y-8"
      v-if="polling"
    >
      <DotPulse />
      <span>This may take a few minutes...</span>
    </div>

    <ul class="mt-4 space-y-2 divide-gray-200" v-if="!polling">
      <li v-for="sale in sales" v-bind:key="sale.id">
        <div
          class="bg-white rounded-md overflow-hidden px-4 py-4 sm:px-6 flex flex-row items-center content-center group relative"
        >
          <input
            name="displayPricingDefault"
            id="displayPricingDefault"
            type="checkbox"
            class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none mr-4"
            v-model="selectedIds[sale.id]"
          />
          <div class="flex-1">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-800 truncate">
                {{ sale.video.title }}
              </p>
              <span
                class="inline-flex items-center px-2.5 py-0.5 text-red-700 bg-red-100 p-2 text-xs rounded-full uppercase"
                v-if="sale.deleted_at !== null"
                >deleted</span
              >
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fad fa-building"></i>
                  </span>
                  <p>{{ sale.network.name }}</p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fas fa-user"></i>
                  </span>
                  <p>
                    {{ sale.owner.name }}
                    <i
                      class="fa-regular fa-circle-exclamation ml-1 text-red-600"
                      v-if="sale.owner.w9_timestamp == null"
                      v-tippy
                      title="User has not submitted a W-9 form yet."
                    ></i>
                  </p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fas fa-coins"></i>
                  </span>
                  <p>${{ sale.price }}</p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                  v-if="sale.video.credit !== null"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fa-solid fa-wallet"></i>
                  </span>
                  <p>{{ sale.video.credit }} credits</p>
                </div>

                <!-- <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                  v-tippy
                  title="Invoice Reference"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fad fa-file-invoice"></i>
                  </span>
                  <p>{{ sale.invoice_number }}</p>
                </div> -->
              </div>

              <div
                class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
              >
                <!-- Heroicon name: solid/calendar -->
                <span class="flex-shrink-0 h-5 w-5 flex items-center">
                  <i class="fad fa-calendar-check"></i>
                </span>
                <p>
                  Purchased on
                  <span
                    >{{ sale.created_at | displayLocalDateTime("M/D/YYYY") }}
                    at
                    {{ sale.created_at | displayLocalDateTime("h:mm a") }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- <div
            class="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 flex flex-row justify-end items-center content-center align-middle p-4 backdrop-filter backdrop-brightness-75 backdrop-opacity-80 backdrop-blur-sm transition select-none"
          >
            <button
              class="px-2 py-1.5 bg-blue-600 rounded-lg text-white shadow-md"
            >
              Finalize Sale
            </button>
          </div> -->
        </div>
      </li>
      <li v-if="polling">
        <div class="flex items-center justify-center py-5">
          <h1 class="text-2xl">
            <i class="fa fa-circle-notch fa-spin text-black"></i>
          </h1>
        </div>
      </li>
    </ul>

    <ApproveVideoSaleModal />
  </div>
</template>

<script>
import * as Config from "@/config";

import Dropdown from "@/components/partials/Dropdown";
import ApproveVideoSaleModal from "@/screens/admin/modals/ApproveVideoSaleModal";
import DotPulse from "@/components/Loaders/DotPulse";
import { EventBus } from "@/utils/events";

export default {
  name: "HelloWorld",
  data() {
    return {
      sales: [],
      networks: [],

      polling: false,

      filterNetworkIndex: null,
      filterNetworkId: null,

      paginate: {},

      invoiceNumber: null,

      selectedIds: {},

      shouldShowFinalizeButton: false
    };
  },
  components: {
    Dropdown,
    ApproveVideoSaleModal,
    DotPulse
  },
  mounted() {
    this.$nextTick(
      function() {
        EventBus.$on("admin-approve-sale-refresh-data", this.getSales);
      }.bind(this)
    );
  },
  methods: {
    async searchInvoice() {
      this.polling = true;
      let res = await this.$http.post(
        Config.apiPath + "/api/v2/admin/sales/search/invoices",
        {
          invoice_number: this.invoiceNumber
        }
      );
      this.sales = res.data;

      this.selectedIds = {}; // reset
      // this.sales.forEach(sale => {
      //   this.selectedIds[sale.id] = false;
      // });

      this.polling = false;
    },
    openViewSaleModal(data) {
      this.$eventBus.$emit("admin-approve-sale-open-modal", data);
    },
    async finalizeSelectedSales() {
      let result = await this.$swal({
        title: "Continue?",
        text:
          "You are about to finalize the selection of sale(s), are you sure?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, finalize."
      });

      if (result.isConfirmed) {
        await this.$http.post(
          Config.apiPath + "/api/v2/admin/sales/multifinalize",
          {
            selectedIds: this.getFilteredSales()
          }
        );
        this.sales = [];
      }
    },
    getFilteredSales() {
      return Object.keys(this.selectedIds).filter(id => {
        return this.selectedIds[id] == true;
      });
    },
    selectAll() {
      console.log("click");

      this.sales.forEach(sale => {
        this.$set(this.selectedIds, sale.id, true);
      });
      // this.$forceUpdate();
    }
  },
  watch: {
    selectedIds: {
      handler() {
        console.log("update");
        let filtered = this.getFilteredSales();
        this.shouldShowFinalizeButton = filtered.length > 0;
      },
      deep: true
    }
  }
};
</script>
